import { apiClient } from '../services/apiClient';
import { ENDPOINTS } from '../constants/endpoints';

export const getAllPartners = () => apiClient.get(ENDPOINTS.PARTNER.BASE);
